var React = require('react');

function IconShowPassword (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"show-a","x1":"100%","x2":"0%","y1":"0%","y2":"100%"},[React.createElement("stop",{"offset":"0%","stopColor":"#593AEC","key":0}),React.createElement("stop",{"offset":"100%","stopColor":"#C54887","key":1})])),React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"url(#show-a)","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","transform":"translate(-188 -891)","key":1},[React.createElement("path",{"d":"M215 899.5s-5.82 7.5-13 7.5-13-7.5-13-7.5 5.82-7.5 13-7.5 13 7.5 13 7.5z","key":0}),React.createElement("path",{"d":"M206 899.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0z","key":1})])]);
}

IconShowPassword.displayName = "IconShowPassword";

IconShowPassword.defaultProps = {"width":"28","height":"17","viewBox":"0 0 28 17"};

module.exports = IconShowPassword;

IconShowPassword.default = IconShowPassword;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/iconShowPassword.svg
// module id = 1091
// module chunks = 22